import { FIND_FEDERATED } from '../constants/actionTypes';
import { PENDING, SUCCESS, ERROR } from '../constants/status';

const initialState = {
  isLoading: false,
  fetched: false,
  federatedData: null,
  isFederated: false,
  federationRedirectUri: '',
  error: null,
};

export function findFederatedReducer(state = initialState, action) {
  const { type, response } = action;

  switch (type) {
    case `${FIND_FEDERATED}_${PENDING}`:
      return {
        ...state,
        isLoading: true,
        fetched: false,
        federatedData: null,
        isFederated: false,
        federationRedirectUri: '',
        error: null,
      };

    case `${FIND_FEDERATED}_${SUCCESS}`:
    //  console.log(response, 'FIND_FEDERATED:::');
      return {
        ...state,
        isLoading: false,
        fetched: true,
        federatedData: response?.data,
        isFederated: response?.data?.federatedUser,
        federationRedirectUri: response?.data?.redirectURI,
        error: null,
      };

    case `${FIND_FEDERATED}_${ERROR}`:
      return {
        ...state,
        isLoading: false,
        fetched: false,
        federatedData: null,
        isFederated: false,
        federationRedirectUri: '',
        error: response?.message,
      };

    default:
      return state;
  }
}
